export default {
  patient: {
    firstName: 'ファーストネーム',
    lastName: '苗字',
    medications: {
      label: '薬',
      new: '新しい薬を追加する',
      warning: {
        noMedications: '薬はありません',
      },
      noMedicationsMessage: 'この人への投薬要求はありません。',
    },
  },
}
